
export type Language = 'zh' | 'en' | 'ja' | 'ko' | 'de' | 'fr' | 'ar' | 'es' | 'ru';

export const translations = {
  zh: {
    dashboard: '控制中心',
    extract: '批量提取',
    help: '使用教程',
    admin: '管理后台',
    settings: '系统设置',
    login: '登录解锁 AI',
    logout: '登出',
    config: '身份配置',
    generate: '生成随机身份',
    generating: '身份计算中...',
    guestMode: '访客模式',
    kernel: '生成内核',
    country: '国家/地区',
    gender: '性别设定',
    ageRange: '年龄区间',
    location: '精准定位 (可选)',
    otherCountry: '其他国家',
    history: '最近记录',
    noHistory: '暂无记录',
    welcome: '万事俱备',
    welcomeDesc: '点击左侧生成按钮，我们将通过 AI 神经网络为您演算一份高度真实的虚拟身份。',
    adminLabel: '系统管理员',
    proLabel: 'Pro 会员',
    quota: '我的额度',
    used: '已使用',
    disclaimer: '法律合规说明',
    copySuccess: '复制成功',
    copyAll: '复制全文',
    aiGenerated: 'AI 生成',
    localGenerated: '本地生成',
    inbox: '收件箱',
    map: '在地图中查看',
    ccInfo: '财务账户信息',
    bio: '背景简介',
    male: '男',
    female: '女',
    random: '随机',
    reset: '重新考虑并同意',
    accessDenied: '访问已终止',
    accessDeniedDesc: '由于您拒绝了我们的免责声明与使用条款，您将无法访问 Identity Pro 系统。',
    confirmDisclaimer: '我同意并进入',
    rejectDisclaimer: '拒绝并退出',
    legalTitle: '每日法律声明确认',
    ssn: 'SSN',
    idCard: '身份证号',
    tempEmail: '真实临时邮箱',
    countries: { US: '美国', CN: '中国', JP: '日本', UK: '英国', DE: '德国', FR: '法国', KR: '韩国', RU: '俄罗斯' }
  },
  en: {
    dashboard: 'Dashboard',
    extract: 'Bulk Extract',
    help: 'Guide',
    admin: 'Admin',
    settings: 'Settings',
    login: 'Login for AI',
    logout: 'Logout',
    config: 'Config',
    generate: 'Generate Identity',
    generating: 'Calculating...',
    guestMode: 'Guest Mode',
    kernel: 'Engine',
    country: 'Country',
    gender: 'Gender',
    ageRange: 'Age Range',
    location: 'Location (Optional)',
    otherCountry: 'Other',
    history: 'History',
    noHistory: 'No Records',
    welcome: 'Ready to Go',
    welcomeDesc: 'Click the generate button, and our AI will synthesize a highly realistic virtual identity for you.',
    adminLabel: 'Admin',
    proLabel: 'Pro Member',
    quota: 'Quota',
    used: 'Used',
    disclaimer: 'Legal Compliance',
    copySuccess: 'Copied',
    copyAll: 'Copy All',
    aiGenerated: 'AI Generated',
    localGenerated: 'Local Mode',
    inbox: 'Inbox',
    map: 'View Map',
    ccInfo: 'Financial Info',
    bio: 'Biography',
    male: 'Male',
    female: 'Female',
    random: 'Random',
    reset: 'Reconsider & Accept',
    accessDenied: 'Access Terminated',
    accessDeniedDesc: 'Access denied as you declined our legal terms and conditions.',
    confirmDisclaimer: 'I Agree',
    rejectDisclaimer: 'Decline',
    legalTitle: 'Daily Legal Consent',
    ssn: 'SSN',
    idCard: 'ID Number',
    tempEmail: 'Disposable Email',
    countries: { US: 'USA', CN: 'China', JP: 'Japan', UK: 'UK', DE: 'Germany', FR: 'France', KR: 'Korea', RU: 'Russia' }
  },
  ru: {
    dashboard: 'Панель',
    extract: 'Извлечение',
    help: 'Справка',
    admin: 'Админ',
    settings: 'Настройки',
    login: 'Войти для ИИ',
    logout: 'Выйти',
    config: 'Конфиг',
    generate: 'Создать личность',
    generating: 'Расчет...',
    guestMode: 'Гостевой режим',
    kernel: 'Ядро',
    country: 'Страна',
    gender: 'Пол',
    ageRange: 'Возраст',
    location: 'Локация (опц.)',
    otherCountry: 'Другая',
    history: 'История',
    noHistory: 'Нет записей',
    welcome: 'Все готово',
    welcomeDesc: 'Нажмите кнопку генерации, и наш ИИ создаст реалистичную виртуальную личность.',
    adminLabel: 'Админ',
    proLabel: 'Pro участник',
    quota: 'Квота',
    used: 'Использовано',
    disclaimer: 'Правовая инфо',
    copySuccess: 'Скопировано',
    copyAll: 'Копировать всё',
    aiGenerated: 'Создано ИИ',
    localGenerated: 'Локальный режим',
    inbox: 'Входящие',
    map: 'На карте',
    ccInfo: 'Финансы',
    bio: 'Биография',
    male: 'Муж.',
    female: 'Жен.',
    random: 'Любой',
    reset: 'Принять условия',
    accessDenied: 'Доступ закрыт',
    accessDeniedDesc: 'Доступ запрещен, так как вы отклонили правовые условия.',
    confirmDisclaimer: 'Я согласен',
    rejectDisclaimer: 'Отказаться',
    legalTitle: 'Ежедневное согласие',
    ssn: 'SSN',
    idCard: 'ID номер',
    tempEmail: 'Временная почта',
    countries: { US: 'США', CN: 'Китай', JP: 'Япония', UK: 'Великобритания', DE: 'Германия', FR: 'Франция', KR: 'Корея', RU: 'Россия' }
  },
  ja: {
    dashboard: 'ダッシュボード',
    extract: '一括抽出',
    help: 'ガイド',
    admin: '管理',
    settings: '設定',
    login: 'AIログイン',
    logout: 'ログアウト',
    config: '設定',
    generate: '身分生成',
    generating: '計算中...',
    guestMode: 'ゲスト',
    kernel: 'エンジン',
    country: '国',
    gender: '性別',
    ageRange: '年齢範囲',
    location: '場所 (任意)',
    otherCountry: 'その他',
    history: '履歴',
    noHistory: '履歴なし',
    welcome: '準備完了',
    welcomeDesc: '生成ボタンをクリックすると、AIが非常にリアルな仮想 ID を作成します。',
    adminLabel: '管理者',
    proLabel: 'Pro会員',
    quota: '割当',
    used: '使用済',
    disclaimer: '法的遵守',
    copySuccess: 'コピー済',
    copyAll: 'すべてコピー',
    aiGenerated: 'AI生成',
    localGenerated: 'ローカル',
    inbox: '受信トレイ',
    map: '地図を見る',
    ccInfo: '財務情報',
    bio: 'プロフィール',
    male: '男',
    female: '女',
    random: 'ランダム',
    reset: '再考して同意',
    accessDenied: 'アクセス終了',
    accessDeniedDesc: '免責事項に同意いただけないため、アクセスできません。',
    confirmDisclaimer: '同意する',
    rejectDisclaimer: '拒否する',
    legalTitle: '法的声明の確認',
    ssn: 'SSN',
    idCard: 'ID番号',
    tempEmail: '一時メール',
    countries: { US: 'アメリカ', CN: '中国', JP: '日本', UK: 'イギリス', DE: 'ドイツ', FR: 'フランス', KR: '韓国', RU: 'ロシア' }
  },
  ko: {
    dashboard: '대시보드',
    extract: '일괄 추출',
    help: '가이드',
    admin: '관리자',
    settings: '설정',
    login: 'AI 로그인',
    logout: '로그아웃',
    config: '설정',
    generate: '신원 생성',
    generating: '계산 중...',
    guestMode: '게스트',
    kernel: '엔진',
    country: '국가',
    gender: '성별',
    ageRange: '연령대',
    location: '위치 (선택)',
    otherCountry: '기타',
    history: '기록',
    noHistory: '기록 없음',
    welcome: '준비 완료',
    welcomeDesc: '생성 버튼을 클릭하면 AI가 매우 사실적인 가상 신원을 합성합니다.',
    adminLabel: '관리자',
    proLabel: 'Pro 회원',
    quota: '할당량',
    used: '사용됨',
    disclaimer: '법적 준수',
    copySuccess: '복사됨',
    copyAll: '전체 복사',
    aiGenerated: 'AI 생성',
    localGenerated: '로컬 모드',
    inbox: '수신함',
    map: '지도 보기',
    ccInfo: '재무 정보',
    bio: '약력',
    male: '남',
    female: '여',
    random: '무작위',
    reset: '동의하기',
    accessDenied: '액세스 종료',
    accessDeniedDesc: '면책 조항에 동의하지 않아 액세스가 거부되었습니다.',
    confirmDisclaimer: '동의함',
    rejectDisclaimer: '거절함',
    legalTitle: '법적 고지 확인',
    ssn: 'SSN',
    idCard: '신분증 번호',
    tempEmail: '임시 이메일',
    countries: { US: '미국', CN: '중국', JP: '일본', UK: '영국', DE: '독일', FR: '프랑스', KR: '한국', RU: '러시아' }
  },
  de: {
    dashboard: 'Dashboard',
    extract: 'Massenextrakt',
    help: 'Anleitung',
    admin: 'Admin',
    settings: 'Einstellungen',
    login: 'AI Login',
    logout: 'Abmelden',
    config: 'Konfig',
    generate: 'Identität generieren',
    generating: 'Berechnung...',
    guestMode: 'Gastmodus',
    kernel: 'Engine',
    country: 'Land',
    gender: 'Geschlecht',
    ageRange: 'Alter',
    location: 'Standort (Opt.)',
    otherCountry: 'Andere',
    history: 'Verlauf',
    noHistory: 'Keine Daten',
    welcome: 'Startklar',
    welcomeDesc: 'Klicken Sie auf den Button, und unsere KI erstellt eine hochrealistische Identität für Sie.',
    adminLabel: 'Administrator',
    proLabel: 'Pro Mitglied',
    quota: 'Kontingent',
    used: 'Benutzt',
    disclaimer: 'Rechtliches',
    copySuccess: 'Kopiert',
    copyAll: 'Alles kopieren',
    aiGenerated: 'KI Generiert',
    localGenerated: 'Lokal',
    inbox: 'Postfach',
    map: 'Karte',
    ccInfo: 'Finanzinfo',
    bio: 'Biografie',
    male: 'Männlich',
    female: 'Weiblich',
    random: 'Zufällig',
    reset: 'Zustimmen',
    accessDenied: 'Zugriff beendet',
    accessDeniedDesc: 'Zugriff verweigert, da Sie die Bedingungen abgelehnt haben.',
    confirmDisclaimer: 'Zustimmen',
    rejectDisclaimer: 'Ablehnen',
    legalTitle: 'Rechtliche Bestätigung',
    ssn: 'SSN',
    idCard: 'Ausweisnr.',
    tempEmail: 'Temp-E-Mail',
    countries: { US: 'USA', CN: 'China', JP: 'Japan', UK: 'GB', DE: 'Deutschland', FR: 'Frankreich', KR: 'Korea', RU: 'Russland' }
  },
  fr: {
    dashboard: 'Tableau de bord',
    extract: 'Extraction',
    help: 'Guide',
    admin: 'Admin',
    settings: 'Paramètres',
    login: 'Connexion AI',
    logout: 'Déconnexion',
    config: 'Config',
    generate: 'Générer',
    generating: 'Calcul...',
    guestMode: 'Mode Invité',
    kernel: 'Moteur',
    country: 'Pays',
    gender: 'Sexe',
    ageRange: 'Âge',
    location: 'Lieu (Opt.)',
    otherCountry: 'Autre',
    history: 'Historique',
    noHistory: 'Aucun record',
    welcome: 'Prêt',
    welcomeDesc: 'Cliquez sur le bouton, notre IA synthétisera une identité virtuelle réaliste.',
    adminLabel: 'Admin',
    proLabel: 'Membre Pro',
    quota: 'Quota',
    used: 'Utilisé',
    disclaimer: 'Conformité',
    copySuccess: 'Copié',
    copyAll: 'Copier tout',
    aiGenerated: 'Généré par IA',
    localGenerated: 'Local',
    inbox: 'Boîte',
    map: 'Carte',
    ccInfo: 'Finances',
    bio: 'Biographie',
    male: 'Homme',
    female: 'Femme',
    random: 'Aléatoire',
    reset: 'Accepter',
    accessDenied: 'Accès terminé',
    accessDeniedDesc: 'Accès refusé car vous avez décliné les conditions.',
    confirmDisclaimer: 'Accepter',
    rejectDisclaimer: 'Refuser',
    legalTitle: 'Consentement légal',
    ssn: 'SSN',
    idCard: 'Numéro ID',
    tempEmail: 'E-mail temporaire',
    countries: { US: 'USA', CN: 'Chine', JP: 'Japon', UK: 'RU', DE: 'Allemagne', FR: 'France', KR: 'Corée', RU: 'Russie' }
  },
  es: {
    dashboard: 'Tablero',
    extract: 'Extracción masiva',
    help: 'Guía',
    admin: 'Admin',
    settings: 'Ajustes',
    login: 'Iniciar sesión AI',
    logout: 'Cerrar sesión',
    config: 'Configuración',
    generate: 'Generar identidad',
    generating: 'Calculando...',
    guestMode: 'Modo invitado',
    kernel: 'Motor',
    country: 'País',
    gender: 'Género',
    ageRange: 'Rango de edad',
    location: 'Ubicación (Opcional)',
    otherCountry: 'Otro',
    history: 'Historial',
    noHistory: 'Sin registros',
    welcome: 'Todo listo',
    welcomeDesc: 'Haz clic en el botón generar, y nuestra IA sintetizará una identidad virtual altamente realista.',
    adminLabel: 'Administrador',
    proLabel: 'Miembro Pro',
    quota: 'Cuota',
    used: 'Usado',
    disclaimer: 'Cumplimiento legal',
    copySuccess: 'Copiado',
    copyAll: 'Copiar todo',
    aiGenerated: 'Generado por IA',
    localGenerated: 'Modo local',
    inbox: 'Bandeja',
    map: 'Ver mapa',
    ccInfo: 'Info financiera',
    bio: 'Biografía',
    male: 'Masculino',
    female: 'Femenino',
    random: 'Aleatorio',
    reset: 'Reconsiderar y aceptar',
    accessDenied: 'Acceso terminado',
    accessDeniedDesc: 'Acceso denegado porque rechazaste los términos legales.',
    confirmDisclaimer: 'Acepto',
    rejectDisclaimer: 'Rechazar',
    legalTitle: 'Consentimiento legal diario',
    ssn: 'SSN',
    idCard: 'DNI/ID',
    tempEmail: 'Email temporal',
    countries: { US: 'EE. UU.', CN: 'China', JP: 'Japón', UK: 'Reino Unido', DE: 'Alemania', FR: 'Francia', KR: 'Corea', RU: 'Rusia' }
  },
  ar: {
    dashboard: 'لوحة التحكم',
    extract: 'استخراج جماعي',
    help: 'دليل الاستخدام',
    admin: 'المشرف',
    settings: 'الإعدادات',
    login: 'تسجيل الدخول للذكاء الاصطناعي',
    logout: 'تسجيل الخروج',
    config: 'التكوين',
    generate: 'إنشاء هوية',
    generating: 'جاري الحساب...',
    guestMode: 'وضع الضيف',
    kernel: 'المحرك',
    country: 'البلد',
    gender: 'الجنس',
    ageRange: 'الفئة العمرية',
    location: 'الموقع (اختياري)',
    otherCountry: 'بلد آخر',
    history: 'السجل',
    noHistory: 'لا توجد سجلات',
    welcome: 'جاهز للانطلاق',
    welcomeDesc: 'انقر على زر الإنشاء، وسيقوم الذكاء الاصطناعي الخاص بنا بتوليد هوية افتراضية واقعية للغاية.',
    adminLabel: 'مشرف',
    proLabel: 'عضو برو',
    quota: 'الحصة',
    used: 'مستخدم',
    disclaimer: 'الامتثال القانوني',
    copySuccess: 'تم النسخ',
    copyAll: 'نسخ الكل',
    aiGenerated: 'توليد الذكاء الاصطناعي',
    localGenerated: 'الوضع المحلي',
    inbox: 'صندوق الوارد',
    map: 'عرض الخريطة',
    ccInfo: 'المعلومات المالية',
    bio: 'السيرة الذاتية',
    male: 'ذكر',
    female: 'أنثى',
    random: 'عشوائي',
    reset: 'إعادة النظر والموافقة',
    accessDenied: 'تم إنهاء الوصول',
    accessDeniedDesc: 'تم رفض الوصول لأنك رفضت الشروط القانونية الخاصة بنا.',
    confirmDisclaimer: 'أوافق',
    rejectDisclaimer: 'رفض',
    legalTitle: 'الموافقة القانونية اليومية',
    ssn: 'رقم الضمان الاجتماعي',
    idCard: 'رقم الهوية',
    tempEmail: 'بريد مؤقت',
    countries: { US: 'أمريكا', CN: 'الصين', JP: 'اليابان', UK: 'بريطانيا', DE: 'ألمانيا', FR: 'فرنسا', KR: 'كوريا', RU: 'روسيا' }
  }
};
